import BranchValidator from "./AppSystem/Helpers/BranchValidator";

export const REDUX_PERSIST_KEY = 'Auth-platform';
//const currentBranch = BranchValidator();
const response = await fetch('/branch-info.json');
const data = await response.json();
const currentBranch = data.branch;

export const API_URL = process.env.NODE_ENV === "development" ? 'https://localhost:7174' : currentBranch === 'master' ? 'https://lrf-kassan-production-b0fahxcggncshrf7.swedencentral-01.azurewebsites.net' : 'https://lrf-kassan-development-hrhqdtetembgfsec.swedencentral-01.azurewebsites.net';

export const APP_URL = process.env.NODE_ENV === "development" ? 'http://localhost:3000' : currentBranch === 'master' ? 'https://kassan.lrf.se' : 'https://kassan-stage.lrf.se';
export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// PUBLIC PATHS
export const PUBLIC_PATHS = {
  APP: '/',
  LOGINQR: '/login-qr',
  LOGINROTEN: '/ssologin',
  LOGINENTRAID: '/entralogin',
  LOGINROTENFROMLRF: '/sso',
  SWEDBANK: '/checkout',
  SWEDBANKPAYMENTCOMPLETED: '/checkout-completed-payment',
  SWEDBANKCOMPLETED: '/checkout-completed',
  SWEDBANKCANCELED: '/checkout-canceled',
  OPENPAYMENTCOMPLETED: '/checkout-openpayment-completed',
  QR_CODE_PUBLIC_INFO: '/qr-code-payment',
  QR_PAYMENT: '/qr-payment',
  REDIRECT_VIEW: '/redirect',
  ERROR_PAGE: '/error-page',
};

// USER PATHS
export const USER_PATHS = {
  APP: '/',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  NOTIFICATIONS: '/notifications',
  LOGOUT: '/logout',
  SETTINGS: '/settings',
  //SETTINGS_TEST:'/setaccount_test',
  SALARY_SHEET: '/salary-sheet',
};

// ADMIN PATHS
export const ADMIN_PATHS = {
  ADMIN_USER: '/admin/user-list',
  ADMIN_ORGANIZATION: '/admin/organization-list',
  ADMIN_USER_INFO: '/admin/user-list/user',
  ADMIN_ORGANIZATION_INFO: '/admin/organization-list/organization',
  ADMIN_ROLE: '/admin/role',
  HONORARIUM: '/admin/honorarium-list/honorarium-create',
  HONORARIUM_INFO: '/admin/honorarium-list/honorarium',
  HONORARIUM_LIST: '/admin/honorarium-list',
  HONORARIUM_UPDATE: '/admin/honorarium-list/honorarium-update',
  ATTEST_LIST_PENDING: '/admin/attest-list-pending',
  ATTEST_LIST_PENDING_PRIMARY: '/admin/attest-list-pending-primary',
  ATTEST_LIST_HISTORY: '/admin/attest-list-history',
  ADMIN_INVOICE_LIST: '/admin/invoice-list',
  ADMIN_INVOICE_CREDIT: '/admin/invoice-list/invoice-credit-create',
  ATTEST_INFO: '/admin/attest-list/attest',
  DIGITAL_ACCOUNT_LIST: '/admin/digital-account-list',
  DIGITAL_ACCOUNT_VIEW: '/admin/digital-account-list/digital-account',
  ACCOUNT_ROW_INFO: '/admin/digital-account-list/digital-account/account-row',
  EXPORT_SIE_DATA: '/admin/export-sie',
  BANK_TRANSFERS_LIST: '/bank-transfer-list',
  BANK_TRANSFERS_INFO: '/bank-transfer-info',
  BANK_TRANSFERS_HISTORY_LIST: '/bank-transfer-list/bank-transfer-history-list',
  HONORARIUM_HISTORY_LIST: '/admin/honorarium-list/honorarium-history-list',
  INTERNAL_TRANSACTION: '/internal-transaction',
  SALARY_SHEET: '/admin/salary-sheet',
  ADMIN_REPORT_TAX: '/admin/report-tax',
  ADMIN_REPORT_TAX_INFO: '/admin/report-tax-info',
  ADMIN_ECONOMIC_REPORT: '/admin/economic-report',
  ADMIN_ECONOMIC_REPORT_INFO: '/admin/economic-report-info',
  ADMIN_COST_BEARER: '/admin/cost-bearer',
  ADMIN_COST_BEARER_UPDATE: '/admin/cost-bearer/update',
  ADMIN_CREATE_COST_BEARER: '/admin/cost-bearer/create',
  ADMIN_ACCOUNTING_LIST: '/admin/accounting-list',
  ADMIN_ACCOUNTING_UPDATE: '/admin/accounting/update',
  ADMIN_ECONOMIC: '/admin/economic',
  ADMIN_INVOICE_ACCOUNTS: '/admin/invoice-accounts',
  ADMIN_ACCOUNTING_CREATE: '/admin/accounting/create',
  ADMIN_API_KEY: '/admin/api-key',
  ADMIN_SWEDBANK_REPORT: '/admin/swedbank-report',
  ADMIN_GUIDE_LIST: '/admin/guide-list',
  //ADMIN_GUIDE_LIST_ONE_TIME: '/admin/guide-list-one-time',
  ADMIN_GUIDE_LIST_UPDATE: '/admin/guide-list/update',
  ADMIN_CALENDAR_ACTIVITY_LIST: '/admin/calendar-activity-list',
  ADMIN_CALENDAR_ACTIVITY_INFO: '/admin/calendar-activity-list/calendar-activity',
};

// SUPER ADMIN PATHS
export const SUPER_ADMIN_PATHS = {
  TRANSACTION: '/super-admin/transaction-list'
};

// ORGANIZATION PATHS
export const ORGANIZATION_PATHS = {
  ORGANIZATION: '/organization',
  ORG_USERS: '/organization-user-list',
  ORG_USERS_INFO: '/organization-user-list/user',
  DIGITAL_ACCOUNT: '/digital-account',
  ACCOUNT_ROW_INFO: '/digital-account/account-row',
  ORG_SALARY_SHEET: '/org/salary-sheet',
  INVOICE_LIST: '/invoice-list',
  INVOICE_CREATE: '/invoice-list/invoice-create',
  INVOICE_CREDIT_CREATE: '/invoice-list/invoice-credit-create',
  QR_CODE_LIST: '/qr-code-list',
  QR_CODE_CREATE: '/qr-code-list/qr-code-create',
  QR_CODE_INFO: '/qr-code-list/qr-code-info',
  ORG_ATTEST: '/organization-attest-list',
  ORG_ATTEST_INFO: '/organization-attest-info',
  ORGANIZATION_ECONOMIC_REPORT: '/organization-economic-report',
  ORGANIZATION_ECONOMIC_REPORT_INFO: '/organization-economic-report-info',
};

//REIMBURSEMENT PATHS
export const REPORT_PROCEEDING_PATHS = {
  REPORT_PROCEEDING: '/report-proceeding-list/report-proceeding-create',
  //REPORT_PROCEEDING_V2: '/report-proceeding-list/report-proceeding-create-v2',
  REPORT_PROCEEDING_INFO: '/report-proceeding-list/report-proceeding',
  REPORT_PROCEEDING_LIST: '/report-proceeding-list'
};

// PAY PATHS
export const PAY_PATHS = {
  PAY: '/pay',
  PAY_INFO: '/pay/pay',
  SWEDBANKPAY: '/pay-quickpayment',
  SWEDBANKPAY_INFO: '/pay-quickpayment/pay',
  SWEDBANKPAY_REPORT_INFO: '/pay-quickpayment/report',
};